import { Box, Breadcrumbs, Link, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import TaskParticipantChart from '../Chart/TaskParticipantChart'
import { backgroundColors } from '../../../Common/Color/Color'
import TeamMemberTable from './TeamMemberTable'
import { useAppDispatch } from '../../../../redux/store'
import { fetchAssignedTeamMembers } from '../../../../redux/reports/task/assignedTeamMemberPerTask/action'
import { clearFilters } from '../../../../redux/reports/task/assignedTeamMemberPerTask/slice'
import { LinkProps, Link as RouterLink, useParams } from 'react-router-dom'
import { useAppSelector } from '../../../../redux/hooks'
import {
  selectAssignedTeamMemberReport,
  selectAssignedTeamMembersLoading,
} from '../../../../redux/reports/task/assignedTeamMemberPerTask/selector'
import PageLoading from '../../../Common/Loading/PageLoading'

const ViewTask: React.FC = () => {
  const dispatch = useAppDispatch()
  const taskDetails = useAppSelector(selectAssignedTeamMemberReport)
  const loading = useAppSelector(selectAssignedTeamMembersLoading)

  const { id: taskId } = useParams<{ id: string }>()

  useEffect(() => {
    // Clear any stale chart filters from a previous visit before fetching new data
    dispatch(clearFilters())
    if (taskId) {
      dispatch(fetchAssignedTeamMembers({ taskId }))
    }
  }, [dispatch, taskId])

  interface LinkRouterProps extends LinkProps {
    to: string
    replace?: boolean
  }

  function LinkRouter(props: LinkRouterProps) {
    return <Link {...props} component={RouterLink as any} underline='hover' color='inherit' />
  }

  if (loading) {
    return <PageLoading message='Loading' subMessage='Fetching team member' />
  }

  return (
    <React.Fragment>
      <Box
        component='div'
        sx={{ p: 0, backgroundColor: backgroundColors.white, width: 'auto' }}
        borderRadius={2}
        boxShadow={1}
      >
        {!loading && !taskDetails && (
          <Box sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant='h6'>No task details found.</Typography>
          </Box>
        )}

        {!loading && taskDetails && (
          <>
            <Box sx={{ p: 2 }}>
              <Breadcrumbs aria-label='breadcrumb'>
                <LinkRouter to='/reports/task'>Tasks</LinkRouter>
                <Typography sx={{ color: 'text.primary' }}>{taskDetails?.taskTitle}</Typography>
              </Breadcrumbs>
            </Box>

            <Box sx={{ px: 2, pt: 0 }}>
              <TaskParticipantChart />
            </Box>
            <TeamMemberTable />
          </>
        )}
      </Box>
    </React.Fragment>
  )
}

export default ViewTask
